<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      color="success"
      :timeout="5000" >
      Umfrage erfolgreich generiert
    </v-snackbar>
    <div class="box pt-2">
      <v-row v-if="!canHaveQuestion" class="mt-0">
        <span class="font-s text-gray px-5 text-center">An dieses Element kann keine Frage angeheftet werden</span>
      </v-row>
      <v-row v-if="canHaveQuestion" class="mt-0">
        <p class="font-m mt-2">
          Verfügbare Fragen für <span class="element">{{decodeElementByName(questionType) }}</span>
        </p>
        <v-spacer />
        <v-btn color="primary" medium elevation="0" @click="openQuestionModal()">
          <v-icon color="#F5F5F5" medium>add</v-icon >
        </v-btn>
      </v-row>

      <v-row v-if="canHaveQuestion" style="height:100%;">
        <multi-select-list :options="this.pxElementQuestions" :selectedOptions="this.questionsForElement" @select="onQuestionSelected" @deselect="onQuestionDeselected"/>
      </v-row>
<!--       <v-row>
        <v-col class="no-spacer">
          <v-btn style="float:right;" class="mx-2" fab small color="primary" @click="addSelectedQuestions()">
            <v-icon dark>
              mdi-chevron-down
            </v-icon>
          </v-btn>
        </v-col>
        <v-col class="no-spacer">
          <v-btn class="mx-2" fab small color="primary" @click="removeSelectedQuestions()">
            <v-icon dark>
              mdi-chevron-up
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <p>An dieses Element angeheftete Fragen</p>
      <v-row class="field">
        <v-card class="fill">
          <multi-select-list :options="this.questionsForElement" :selectedOptions="this.selectedQuestions" @select="onDownQuestionSelected"/>
        </v-card>
      </v-row> -->
    </div>

  <PxCreateQuestionPageInModel v-if="canHaveQuestion" ref="createDialog" />
  </div>
</template>

<script>
import MultiSelectList from '@/components/common/MultiSelectList.vue';

import pxQuestionProcessService from "./px-question-process-service";
import AddSurveyTextDialog from '@/components/common/AddSurveyTextDialog.vue';
import { getBusinessObject } from 'prime-custom-modeling/lib/util/ModelUtil';
import PxCreateQuestionPageInModel from './PxCreateQuestionPageInModel.vue';
import {decodeElementByName} from "@/components/util.js"
export default {
  components: { MultiSelectList, AddSurveyTextDialog, PxCreateQuestionPageInModel },
  props: {
    uuid: String,
    element: Object,
  },
  data: function () {
    return {
      questionsForElement: [],
      selectedQuestions: [],
      pxElementQuestions: [],
      elementId: "",
      loadingProgress: 0,
      snackbar: false,
      questionType: "",
      canHaveQuestion: true
    };
  },
  mounted: function () {
    const bo = getBusinessObject(this.element);
    if((bo.taskType != null && bo.icon) || bo.$attrs.taskType != null){
      this.canHaveQuestion = false;
    }else{
      this.canHaveQuestion = true;
      this.loadQuestions(this.element.id);
    }    
  },
  watch: {
    element: function (newVal, oldVal) {
      const bo = getBusinessObject(newVal);
      if((bo.taskType != null && bo.icon) || bo.$attrs.taskType != null){
      this.canHaveQuestion = false;
    }else{
      this.canHaveQuestion = true;
      this.loadQuestions(newVal.id);
    }
    },
  },
  methods: {
    decodeElementByName: decodeElementByName,
    loadQuestions(id){
      this.pxElementQuestions = [];
      this.elementId = id;
      this.selectedQuestions = [];
      if(this.element.type == null) {
        this.questionType="Process";
      }else{      
        if(this.element.type.includes("Task")){
          this.questionType="Activity";
        }else if(this.element.type.includes("SubProcess")){
          this.questionType="Activity";
        }else if((this.element.type.includes("Process") && !this.element.type.includes("Sub")) || this.element.type.includes("Collaboration") || this.element.type.includes("Participant")){
          this.questionType="Process";
        }else if(this.element.type.includes("Event")){
          this.questionType="Event";
        }else if(this.element.type.includes("Flow")){
          this.questionType="Flow";
        }else if(this.element.type.includes("Lane")){
          this.questionType="Lane";
        }else if(this.element.type.includes("DataStore")){
          this.questionType="DataStore";
        }else if(this.element.type.includes("DataObject")){
          this.questionType="DataObject";
        }else if(this.element.type.includes("Gateway")){
          this.questionType="Gateway";
        }
      }
      pxQuestionProcessService.retrievePxIwakQuestionsForElement(this.questionType, this.uuid).then((res) => {
        this.pxElementQuestions = res.data;
        this.fetchQuestionsForElement();
      })
    },
    isSelected(id){
        if(this.selectedOptions.length > 0 && this.selectedOptions.find(elem => elem.id == id) != null){
            return true;
        }
        return false;
    },
    async fetchQuestionsForElement(){
      pxQuestionProcessService.retrievePxQuestionsForElement(this.uuid, this.elementId).then(response => {
          let elementQuestionIds = response.data.map(elem => elem.id);
          this.questionsForElement = response.data;
          this.pxElementQuestions = this.pxElementQuestions.filter(elem => !elementQuestionIds.includes(elem.id));
          this.selectedQuestions.splice(0,this.selectedQuestions.length)
          this.loadingProgress = 100;
        })
    },
    async onQuestionSelected(questionId){
      const bo = getBusinessObject(this.element);
      let name = "";
      if(bo!= null && bo.name != null) name = bo.name;
      if(bo.$type.includes("Process") || bo.$type.includes("Collaboration")) name = "Gesamter Prozess";
      await pxQuestionProcessService.linkQuestionsToElement(this.uuid, this.elementId, questionId, name);
      //this.questionsForElement = this.questionsForElement.concat(this.selectedQuestions);
      //this.pxElementQuestions = this.pxElementQuestions.filter(elem => !this.selectedQuestions.includes(elem));
      //this.selectedQuestions.splice(0,this.selectedQuestions.length);
      if(this.questionsForElement.length == 1) this.$emit("refresh");
    },
    async onQuestionDeselected(questionId){
      await pxQuestionProcessService.removeQuestionFromElement(this.uuid, this.elementId, questionId);
      /* this.pxElementQuestions = this.pxElementQuestions.concat(this.selectedQuestions);
      this.questionsForElement = this.questionsForElement.filter(elem => !this.selectedQuestions.includes(elem));
      this.selectedQuestions.splice(0,this.selectedQuestions.length); */
      if(this.questionsForElement.length == 0) this.$emit("refresh");
    },
    findCommonElements(arr1, arr2) {
      return arr1.some(item => arr2.includes(item))
    },
    openQuestionModal(){
      this.$refs.createDialog.open(this.element.id).then(() => {
        this.loadQuestions(this.element.id);
      })
    }
  },
};
</script>
<style scoped>
.field{
  height: 40% !important;
  margin-bottom: 5px !important;
}
.fill{
  height:100%;
  width:100%;
  overflow:auto
}
.box {
  top: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  padding: 0px 25px !important;
  height: calc(100% - 15px - 32px);
  box-shadow: unset !important;
}
#footerButton{
  background-color: rgb(245, 245, 245);
  position:absolute;
  bottom:15px;
  height:32px;
  width:100%;
}
.element {
  color: var(--v-primary-base);
  position: relative;
  font-weight: 700;
}
.element::before {
  position: absolute;
  top: 8px;
  background: var(--v-primary-base);
  opacity: .1;
  content: '';
  width: 100%;
  height: 10px;
}
:deep .v-list-item.selected {
  padding-right: 25px;
}
</style>